/**
 * Главная страница (02_GPT-MODULAR).
 * Только сборка блоков. Плашка остаётся в LayoutWithPlank.
 */

import { useNavigate } from "react-router-dom";
import PcScrollShowcase from "../components/PcScrollShowcase/PcScrollShowcase";
import HomeAbout from "./HomeAbout";
import HomeOrder from "./HomeOrder";
import HomeTeam from "./HomeTeam";
import HomeProcess from "./HomeProcess";
import HomeReviews from "./HomeReviews";

function HomePage() {
    const navigate = useNavigate();

    const handleSendEmailClick = () => {
        navigate('/contact', { state: { scrollToForm: true } });
    };

    return (
                <>
                    <HomeAbout />
                    <HomeOrder onSendEmail={handleSendEmailClick} />
                    <PcScrollShowcase onSendEmail={handleSendEmailClick} />
                    <HomeTeam />
                    <HomeProcess />
                    <HomeReviews onSendEmail={handleSendEmailClick} />
                </>
    );
}

export default HomePage;
// pages/HomePage.js
